<template>
  <div>
    <nav-title :color="false" :title="'Quick tips'" />

    <empty-module
      v-if="getTipsList.length == 0"
      :title="'There are no quick tips available for this problem'"
      :icon="'contact_support'"
    />

    <section v-else class="container">
      <h5 class="text-center p-3 m-0 text-darked">
        {{ problemName }}
      </h5>
      <div class="px-3">
        <hr class="my-0" />
        <div class="p-3">
          <p>
            Choose the tip(s) that might work best for your child.
          </p>
        </div>

        <b-list-group v-for="item in getTipsList" :key="item.id" class="mx-3">
          <b-list-group-item
            button
            @click="goDetailTips(item.value, item.text)"
            class="d-flex justify-content-between align-items-center my-1 border-0 shadow-sm p-2"
          >
            {{ item.text }}
            <i class="material-icons align-middle">
              keyboard_arrow_right
            </i>
          </b-list-group-item>
        </b-list-group>

        <div class="mt-4 p-3 text-center">
          <p class="py-2 text-muted">
            Need more help?
          </p>
          <b-button
            variant="outline-warning"
            class="p-1 m-1 m-auto"
            block
            @click="goSolving()"
          >
            Problem Solving
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import emptyModule from "@/components/general/emptyModule.vue";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  components: {
    navTitle,
    emptyModule
  },
  methods: {
    goDetailTips(id, name) {
      this.$router.push({
        name: "HelpQuickSkill",
        query: {
          name: name,
          tip: id
        }
      });
    },
    getProblemName() {
      this.getProblemList.forEach(element => {
        const elmt = this.$route.params.Mid;
        if (element.value == elmt) {
          this.problemId = elmt;
          this.problemName = element.text;
        }
      });
    },
    goSolving() {
      let Mid = this.problemId;
      this.$router.push({
        path: `/help-select-cause/${Mid}`
      });
    }
  },
  computed: {
    ...mapGetters("help", ["getProblemList"]),
    ...mapGetters("help", ["getTipsList"])
  },
  beforeRouteEnter(to, from, next) {
    let problemId = to.params.Mid;
    Promise.all([store.dispatch("help/FetchTips", problemId)]).then(() => {
      next();
    });
  },
  mounted() {
    this.getProblemName();
  },
  data() {
    return {
      problemName: null,
      problemId: null
    };
  },
  props: {
    problems: Array
  }
};
</script>
